export const mobileNav = {
    toggle(){
        const toggle = document.querySelector('.mobile-nav-toggle');
        const closer = document.querySelector('.mobile-nav-close');
        const menu = document.querySelector('.scs-header .navbar');
        const overlay = document.querySelector('.mobile-nav-overlay');

        if(menu){
            toggle.addEventListener('click', function(){
                menu.classList.add('active');
            });

            closer.addEventListener('click', function(){
                menu.classList.remove('active');
            });

            overlay.addEventListener('click', function(){
                menu.classList.remove('active');
            });
        }
    },
    collapse(){
        const navItem = document.querySelectorAll('.scs-header .nav-toggle');
        //const localeItem = document.querySelector('.locale-selector-mobile > ul > li');

        for(let i = 0; i < navItem.length; i++){
            navItem[i].addEventListener('click', () =>{
                const parent = navItem[i].closest('li');
                parent.classList.toggle('collapsed');
            });
        }
    },
    initialize(){
        const navItems = document.querySelectorAll('.scs-header .menu-item');
        for(let i = 0; i < navItems.length; i++){
            navItems[i].classList.add('collapsed');
        }
    }
}